import { render, staticRenderFns } from "./ViewWaivers.vue?vue&type=template&id=67cc90a4"
import script from "./ViewWaivers.vue?vue&type=script&lang=js"
export * from "./ViewWaivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports